'use client';

import { AppErrorFallback } from './app-error-fallback';

/** Root route error boundary (renders inside the root layout and its providers). */
export default function RouteError({
  error,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return <AppErrorFallback error={error} />;
}
